import React from 'react';
import styles from './Navbar.module.css';

const NavbarLogo = () => {
  return (
    <div className={styles.header}>
      <h1 className={styles.title}>AXELSSONS ELEKTRISKA</h1>
      <div className={styles.logo_part_one}></div>
      <div className={styles.logo_part_two}></div>
    </div>
  );
};

export default NavbarLogo;
